<template>
  <div>
    <div class="ui">
      <div class="ui internally grid centered">
        <div class="row">
          <div class="eight wide column">
            <div class="ui">
              <div class="ui items">
                <div class="item">
                  <div class="medium image">
                    <img
                      :src="partnerLogoUrl"
                      style="max-height: 120px; margin-top: 20px"
                    />
                  </div>
                  <div class="middle aligned content">
                    <div class="description">
                      <div class="ui one column stackable center aligned grid">
                        <div class="middle aligned row">
                          <div class="column">
                            <div class="content" style="font-size: large">
                              <vue-particles
                                color="#dedede"
                                :particleOpacity="0.7"
                                :particlesNumber="400"
                                shapeType="circle"
                                :particleSize="4"
                                linesColor="#dedede"
                                :linesWidth="1"
                                :lineLinked="true"
                                :lineOpacity="0.4"
                                :linesDistance="150"
                                :moveSpeed="2"
                                :hoverEffect="true"
                                hoverMode="grab"
                                :clickEffect="true"
                                clickMode="push"
                                style="height: 120px"
                              ></vue-particles>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <h4 class="ui horizontal divider header">
              <i class="calculator icon"></i>
              Create Plans
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <div class="ui padded segment">
              <div class="ui divided items">
                <div class="item">
                  <div class="image">
                    <img
                      src="@/assets/retirement.jpeg"
                      class="ui medium image"
                      style="
                        max-height: 250px;
                        opacity: 0.75;
                        border-radius: 15px;
                      "
                    />
                  </div>

                  <div class="content">
                    <div class="header">New Post Retirement Plan</div>
                    <div class="meta">
                      <span
                        >Can I sustain my living standards throughout
                        retirement?</span
                      >
                    </div>
                    <div class="description">
                      <p></p>
                    </div>
                    <div class="extra">
                      <div class="ui label">
                        <router-link to="/postretirementproposal"
                          >Create Plan</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="false == true">
          <div class="eight wide column">
            <h4 class="ui horizontal divider header">
              <i class="mail icon"></i>
              System Messages
            </h4>

            <div class="ui padded segment">
              <table class="ui compact celled definition table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Registration Date</th>
                    <th>E-mail address</th>
                    <th>Premium Plan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="collapsing">
                      <label>View</label>
                    </td>
                    <td>John Lilki</td>
                    <td>September 14, 2013</td>
                    <td>jhlilk22@yahoo.com</td>
                    <td>No</td>
                  </tr>
                  <tr>
                    <td class="collapsing"></td>
                    <td>Jamie Harington</td>
                    <td>January 11, 2014</td>
                    <td>jamieharingonton@yahoo.com</td>
                    <td>Yes</td>
                  </tr>
                  <tr>
                    <td class="collapsing"></td>
                    <td>Jill Lewis</td>
                    <td>May 11, 2014</td>
                    <td>jilsewris22@yahoo.com</td>
                    <td>Yes</td>
                  </tr>
                </tbody>
                <tfoot class="full-width">
                  <tr>
                    <th></th>
                    <th colspan="4">
                      <div class="ui right floated small primary labeled">
                        <router-link to="/messages">
                          <i class="mail icon"></i> View all
                        </router-link>
                      </div>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      currentText: 0,

      results: {},
    };
  },

  computed: {
    partnerLogoUrl() {
      return this.$store.state.partnerLogoUrl;
    },
    marketingMessage() {
      if (this.$store.state.partnerId == 2) {
        return "We make it our personal responsibility to craft strategic, personalised financial plans. By helping you manage your finances,  we ensure that your money is working as hard as it possibly can for you.";
      } else
        return "We create strategic, personalised financial plans to ensure that you can meet your life's goals.";
    },
    ...mapState,
  },
  methods: {},
  mounted: function () {
    // this._counter = setInterval(() => {
    //   this.currentText = (this.currentText + 1) % 6;
    // }, 1100);
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.particles {
  height: 120px;
}
</style>
